var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondaryCodeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0602 7.12856C10.2656 7.31351 10.2822 7.62994 10.0972 7.83534L6.34878 11.9984L10.1001 16.1647C10.285 16.3701 10.2685 16.6865 10.0631 16.8715C9.85767 17.0564 9.54124 17.0398 9.3563 16.8344L5.02 12.0185L5 12.0005L9.35338 7.16559C9.53833 6.96018 9.85478 6.9436 10.0602 7.12856ZM13.9385 16.8714C13.7331 16.6865 13.7165 16.3701 13.9014 16.1647L17.6499 12.0016L13.8985 7.83532C13.7136 7.62992 13.7302 7.31349 13.9356 7.12855C14.141 6.94361 14.4574 6.96019 14.6423 7.16558L18.9786 11.9815L18.9986 11.9995L14.6453 16.8344C14.4603 17.0398 14.1439 17.0564 13.9385 16.8714Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryCodeSmall);
export default __webpack_public_path__ + "static/media/secondary_code_small.47eacbf0d8dcb7b40d8b5a04b115d2eb.svg";
export { ForwardRef as ReactComponent };